export enum MetadataKey {
  Routes             = 'hans_routes',
  Port               = 'hans_app_port',
  Name               = 'hans_app_name',
  SocketIORoutes     = 'hans_socket_io_routes',
  NativeSocketRoutes = 'hans_native_socket_routes',
  GraphqlRoutes      = 'hans_graphql_routes',
  Middleware         = 'hans_middleware',
  AppMiddleware      = 'hans_app_middleware',
  Adapter            = 'hans_app_adapter',
  Configuration      = 'hans_app_configuration',
  PublicDirectory    = 'hans_public_directory',
}
